import React from "react";
import { useNavigate } from "react-router-dom";
import { useLang } from "@/LanguageContext";

export default function Footer() {
  const { t } = useLang();
  const navigate = useNavigate();
  const f = t.footer;
  const year = new Date().getFullYear();

  const goSection = (id) => {
    if (window.location.pathname === "/") {
      const el = document.getElementById(id);
      if (el) (window.__lenis ? window.__lenis.scrollTo(el, { offset: -20 }) : el.scrollIntoView({ behavior: "smooth" }));
    } else {
      navigate(`/#${id}`);
    }
  };
  const goPage = (p) => { navigate(p); window.scrollTo(0, 0); };

  const links = [
    { fn: () => goSection("about"), label: f.links.about },
    { fn: () => goSection("destinations"), label: t.nav.destinations },
    { fn: () => goPage("/tarifs"), label: t.nav.tarifs },
    { fn: () => goPage("/partenaires"), label: t.nav.partners },
    { fn: () => goPage("/espace-client"), label: t.nav.client },
    { fn: () => goSection("contact"), label: f.links.contact },
  ];
  return (
    <footer data-testid="footer" className="bg-navy-deep border-t border-gold/20 pt-20 pb-10">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-3 gap-12">
          <div>
            <img src="/logo.png" alt="French Touch Concierge" className="h-28 w-auto object-contain" />
            <p className="text-white/50 text-sm font-light mt-5 max-w-xs">{f.tagline}</p>
            <address className="not-italic text-white/60 text-sm font-light mt-5 leading-relaxed">
              4300 Biscayne Blvd, Suite 203<br />
              Miami, FL 33137<br />
              <a href="tel:+13057729152" data-testid="footer-phone" className="link-gold hover:text-white">+1 (305) 772 9152</a><br />
              <a href="mailto:contact@frenchtouchconcierge.com" data-testid="footer-address-email" className="link-gold hover:text-white">contact@frenchtouchconcierge.com</a>
            </address>
            <p className="text-gold/70 text-xs tracking-luxe uppercase mt-4">Miami · France</p>
          </div>
          <div>
            <h4 className="text-gold text-xs tracking-luxe uppercase mb-5">{f.cols.explore}</h4>
            <ul className="space-y-3">
              {links.map((l) => (
                <li key={l.label}>
                  <button onClick={l.fn} className="link-gold text-white/70 hover:text-white text-sm font-light">{l.label}</button>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-gold text-xs tracking-luxe uppercase mb-5">{f.cols.connect}</h4>
            <ul className="space-y-3">
              <li><a href="https://www.instagram.com/french_touch_concierge/" target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" className="link-gold text-white/70 hover:text-white text-sm font-light">Instagram</a></li>
              <li><a href="https://www.linkedin.com/in/french-touch-concierge-933983425/" target="_blank" rel="noopener noreferrer" data-testid="footer-linkedin" className="link-gold text-white/70 hover:text-white text-sm font-light">LinkedIn</a></li>
              <li><a href="mailto:contact@frenchtouchconcierge.com" data-testid="footer-email" className="link-gold text-white/70 hover:text-white text-sm font-light">contact@frenchtouchconcierge.com</a></li>
            </ul>
          </div>
        </div>
        <div className="gold-line w-full mt-16 mb-6 opacity-40" />
        <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-white/40 text-xs font-light">© {year} French Touch Concierge. {f.rights}</p>
          <p className="text-white/40 text-xs font-light">{f.legal}</p>
        </div>
      </div>
    </footer>
  );
}
